var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 2C5.49156 2 4.60156 2.89 4.60156 4V20C4.60156 20.5304 4.81228 21.0391 5.18735 21.4142C5.56242 21.7893 6.07113 22 6.60156 22H10.6016V20.09L12.6916 18H6.60156V16H14.6916L16.6916 14H6.60156V12H18.6916L20.6016 10.09V8L14.6016 2H6.60156ZM13.6016 3.5L19.1016 9H13.6016V3.5ZM20.7516 13C20.6016 13 20.4616 13.05 20.3516 13.16L19.3316 14.18L21.4216 16.26L22.4416 15.25C22.6516 15.03 22.6516 14.67 22.4416 14.46L21.1416 13.16C21.0316 13.05 20.8916 13 20.7516 13ZM18.7416 14.77L12.6016 20.92V23H14.6816L20.8316 16.85L18.7416 14.77Z",
    fill: "#4EC98A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentEdit);
export default __webpack_public_path__ + "static/media/document-edit.91647f26cfaf16c061fe2c5ebc5b183a.svg";
export { ForwardRef as ReactComponent };